// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2e0d603a","551":"533a048f"}[chunkId] + ".chunk.js";
};